import { slideDown, slideUp } from "slide-anim";

function getNextSiblings(elem, filter) {
    var sibs = [];
    var nextElem = elem.parentNode.firstChild;
    do {
        if (nextElem.nodeType === 3) continue; // ignore text nodes
        if (nextElem === elem) continue; // ignore elem of target
        if (nextElem === elem.nextElementSibling) {
            if (!filter || filter(elem)) {
                sibs.push(nextElem);
                elem = nextElem;
            }
        }
    } while ((nextElem = nextElem.nextSibling));
    return sibs;
}

export const readMore = function (el) {
    const readLess = document.createElement("span");
    readLess.classList.add("link");
    readLess.innerHTML = "<span>Read less</span> -";
    const parent = el.closest("p").parentNode;

    el.addEventListener("click", function (evt) {
        this.closest("p").style.display = "none";
        getNextSiblings(this.closest("p")).forEach(function (item) {
            slideDown(item); //.style.display = "block";
        });
        parent.appendChild(readLess);
    });

    readLess.addEventListener("click", function (evt) {
        getNextSiblings(el.closest("p")).forEach(function (item) {
            slideUp(item);
            el.closest("p").style.display = "block";
        });
    });

    el.parentNode.style.marginBottom = "0px";

    getNextSiblings(el.closest("p")).forEach(function (item) {
        item.style.display = "none";
    });
};
